import { DataTable, Dialog, Loader } from "@/components";
import { Button } from "@/components/ui";
import useAnnualReporting from "./useAnnualReporting";
import { Outlet } from "react-router-dom";
import { useState } from "react";

const tabs = ["Ostwal"];

const AnnualReporting = () => {
  const [activeTab, setActiveTab] = useState("Ostwal");
  const {
    onAdd,
    columns,
    openDialog,
    setOpenDialog,
    deletedRow,
    isDeletePending,
    onDeleteConfirm,
    annualReportingList,
    isAnnualReportingLoading,
  } = useAnnualReporting(activeTab);


  return (
    <div className="p-4 md:p-6">
      {/* Tabs */}
            <div className="flex items-center gap-4 mb-4 border-b pb-2">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 rounded-t-md font-medium transition-colors duration-150 cursor-pointer ${
                    activeTab === tab
                      ? "text-[#E2544B] border-b-2 border-[#E2544B]"
                      : "text-gray-500 hover:text-[#E2544B]"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-end justify-end w-full">
          <Button
            onClick={() => onAdd(activeTab)}
            className="px-4"
            disabled={isAnnualReportingLoading}
          >
            + Add
          </Button>
        </div>
      </div>

      {isAnnualReportingLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={(annualReportingList?.data?.items || [])?.sort(
            (a: any, b: any) =>
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          )}
        />
      )}

      {openDialog && (
        <Dialog
          open={openDialog}
          setOpen={setOpenDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          saveText="Delete"
          saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
          isLoading={isDeletePending}
          onSave={onDeleteConfirm}
        >
          <p className="text-sm">
            Are you sure you want to delete this Annual Reporting -{" "}
            <span className="font-bold text-primary">{deletedRow?.name}</span>?
          </p>
        </Dialog>
      )}
      <Outlet />
    </div>
  );
};

export default AnnualReporting;
